import wretch from '@wayfair/wretch';
import {initBreadcrumbBuffer} from './breadcrumbs';
import {Transport} from '@wayfair/logger';

export const DEFAULT_ENDPOINT = '/a/logging/logjs';

/**
 * Creates logger transport to be used by the client bundle.
 *
 * @param options
 * @param options.endpoint The logging endpoint
 * @param options.breadcrumbEvents Breadcrumb events to log
 * @param options.maxRetries Number of retries in the case of network issues
 * @returns A client transport
 */
export default function createWretchTransport({
  endpoint = DEFAULT_ENDPOINT,
  breadcrumbEvents = [],
  maxRetries = 3,
}: {
  endpoint?: string;
  breadcrumbEvents?: string[];
  maxRetries?: number;
} = {}): Transport {
  const breadcrumbBuffer = initBreadcrumbBuffer(breadcrumbEvents);

  return function clientTransport({
    loggerName,
    level,
    message,
    transactionID,
    data,
  }) {
    (function sendLog(retry: number = 1) {
      wretch(endpoint)
        .json({
          logger: [
            {
              logger: loggerName,
              message,
              mdc: {
                breadcrumbs: breadcrumbBuffer.getBreadcrumbsString(),
                ...data,
              },
              severityLevel: level,
              type: 'L',
            },
          ],
          transactionID,
        })
        .post()
        .res()
        .catch(() => {
          if (retry >= maxRetries) {
            return;
          }

          setTimeout(() => {
            sendLog(retry + 1);
          }, 1000 * (Math.pow(2, retry) - 1));
        });
    })();
  };
}
